module.exports = __webpack_public_path__ + "img/ketang_normal.ff9b705a.png";